<template>
    <div 
        id="div_pesquisaAnotacoes"
        ref="div_pesquisaAnotacoes"
        class="pesquisa-anotacoes-container"
    >
        <section class="pesquisa-anotacoes__header">
            <!-- Pesquisa de Termos de anomalia -->
            <div class="input__container">
                <SearchSvgIcon v-if="!search.termValue" class="input__icon" />
                <CloseSvgIcon v-else class="input__icon input__icon--clear" @click="handleClearSearchTerm" />
                <input ref="input_searchTerm" v-model="search.termValue" type="text" @focus="search.focusedInput = true" @blur="search.focusedInput = false"
                name="pesquisa-termos" @keydown.escape="handleClearSearchTerm" placeholder="Digite o procedimento" class="input__field" />
            </div>
        </section>

        <section class="pesquisa-anotacoes__content">
            <rootNodeSearch v-for="(node, index) in filteredRootNodes" :key="node.id"
                :node="node"
                :execMode="'work'"
                :id="node.id"
                :activeNode="node.id == activeNode?.step ? activeNode : null"
                :orderNumber="index + 1"
                :searchValue="search.termValue"
                :searchMode="search.mode == 'search'"
            ></rootNodeSearch>
        </section>

    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import _ from 'lodash';
import rootNodeSearch from './rootNodeSearch.vue';
import { gConsts } from '@/globals/gConsts';
import { reportUtils } from '@/features/report/lib/reportUtils';
import { evtBus  } from '@/main';
import { nodes   } from '@/globals/nodes';
import { mapGetters, mapState, mapActions } from 'vuex';

import SearchSvgIcon from '@/assets/icons/search.svg';
import CloseSvgIcon from '@/assets/icons/close.svg';


export default {
    name : 'pesquisaAnotacoesCMP',
    components: {
        // nodeCMP,
        rootNodeSearch,
        SearchSvgIcon,
        CloseSvgIcon,
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    props: {
        active  : Boolean,
        label   : String,
        panelId : String,
        open    : Boolean,
    }, 

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data() {
        return {
            gConsts: gConsts,
            activeNode: {
                step: null,
                layer: null,
                label: null,
            },
            search: {
                mode: 'normal',
                termValue: '',
                focusedInput: false,
                cursor: {
                    position: 0,
                    labelId: null,
                    active: false,
                }
            },
            filteredRootNodes: [],
        };
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------
    
    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_rootNodes',
            'GET_nodeSearchStr',
            'GET_togglesNodeSearch',
            'GET_filteredNodes',
        ]),

        currentFilteredNodesBySearchTerm() {
            return this.GET_filteredNodes.filter(node => {
                if (node.layout.type !== gConsts.node.layout.types.LABEL)
                    return false;
                return reportUtils.labelSearchForReportMatches(node, this.search.termValue);
            });
        },

    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch: {
        open(newVal, oldVal) {
            if (!newVal) {
                this.search.mode = 'normal';
                this.search.termValue = '';
                this.search.focusedInput = false;
                this.resetCurrentCursor();
                this.search.cursor.active = false;
                this.$refs.input_searchTerm.blur();
            } else {
                this.updateFilteredRootNodes(this.search.termValue);
            }
        },

        'search.termValue': {
            handler(newVal, oldVal) {
                this.search.cursor.active = newVal.trim().length > 0;
                this.search.mode = this.search.cursor.active ? 'search' : 'normal';
                this.resetCurrentCursor();
                if (this.$updateFilteredRootNodes)
                    this.$updateFilteredRootNodes(newVal);
            },
            immediate: true
        },
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
            'ACT_uiUpdate',
            'ACT_runtimeUpdate',
            'ACT_reportNodes_addNewLabelReportText',
        ]),

        handleClearSearchTerm() {
            if (!this.search.termValue) {
                console.log('clearing search term');
                evtBus.$emit('evt_sidebarPanel_collapse');
                return;
            }
            this.search.termValue = '';
        },

        handleActivateNode(payload) {
            var rootNode, layerNode, firstLabelNode;
            console.log('relatorioDinamico.handleActivateNode', payload);
            if (payload.nodeId == null || payload.nodeType == null)
                return;

            var newActiveNode = this.GET_filteredNodes.find(node => node.id == payload.nodeId);

            if (!newActiveNode)
                return;

            // console.log('relatorioDinamico.handleActivateNode.newActiveNode: ', newActiveNode);

            switch (payload.nodeType) {
                case gConsts.node.layout.types.LABEL :
                    if (newActiveNode.id == this.activeNode.label) {
                        this.activeNode.label = null;
                    } else {
                        layerNode = this.GET_filteredNodes.find(node => node.id == newActiveNode.layout.parent);
                        rootNode = this.GET_rootNodes.find(node => node.id == layerNode.layout.parent);
                        this.activeNode = {
                            step: rootNode.id,
                            layer: layerNode.id,
                            label: newActiveNode.id,
                        };
                    }
                    break;
                case gConsts.node.layout.types.LAYER :
                    if (newActiveNode.id == this.activeNode.layer) {
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        rootNode = this.GET_rootNodes.find(node => node.id == newActiveNode.layout.parent);
                        firstLabelNode = this.GET_filteredNodes.find(node => node.layout.parent == newActiveNode.id)?.[0] ?? null;
                        this.activeNode = {
                            step: rootNode.id,
                            layer: newActiveNode.id,
                            label: firstLabelNode?.id ?? null,
                        };
                    }
                    break;
                case gConsts.node.layout.types.STEP :
                    if (newActiveNode.id == this.activeNode.step) {
                        this.activeNode.step = null;
                        this.activeNode.layer = null;
                        this.activeNode.label = null;
                    } else {
                        var layerId = null;
                        if (newActiveNode.id == 'step_denticao') {
                            layerId = 'layer_dentesSeg';
                        }

                        this.activeNode = {
                            step: newActiveNode.id,
                            layer: layerId,
                            label: null,
                        };
                    }
                    break;
            }

            this.ACT_runtimeUpdate({ active : this.activeNode });
            evtBus.$emit('evt_activateNode', this.activeNode);
        },

        onSearchActionEvent(newSearchTerm) {
            if (this.search.focusedInput) {
                return;
            }
            // this.search.termValue = newSearchTerm;
            this.search.mode = 'search';
            if (this.$refs.input_searchTerm)
                this.$refs.input_searchTerm.focus();

            this.refreshCurrentCursor();
        },

        onSearchActionCursorMove(direction) {
            if (direction == 'next') {
                this.search.cursor.position++;
            } else if (direction == 'previous') {
                this.search.cursor.position--;
            }
            if (this.search.cursor.position < 0) {
                this.search.cursor.position = this.currentFilteredNodesBySearchTerm.length - 1;
            } else if (this.search.cursor.position >= this.currentFilteredNodesBySearchTerm.length) {
                this.search.cursor.position = 0;
            }
            this.refreshCurrentCursor();
        },

        onSearchActionCursorSelectTerm() {
            if (this.search.cursor.active && this.search.cursor.labelId) {
                if (this.search.cursor.labelId !== this.activeNode.label) {
                    evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.search.cursor.labelId, nodeType: gConsts.node.layout.types.LABEL });
                    this.ACT_reportNodes_addNewLabelReportText({ labelId: this.search.cursor.labelId });
                }
                evtBus.$emit('evt_sidebarPanel_collapse');
            }
        },

        updateFilteredRootNodes(searchTerm) {
            var rootNodes = this.GET_rootNodes;
            // Anatomia fica fora do painel. Apenas disponivel no painel de anatomia.
            rootNodes = rootNodes.filter(rootNode => rootNode.id != 'step_anatomia');
            if (!searchTerm.trim()) {
                this.filteredRootNodes = rootNodes;
                this.refreshCurrentCursor();
                return;
            }
            this.filteredRootNodes = rootNodes.filter(rootNode => {
                const layerNodes = this.GET_filteredNodes.filter(node => node.layout.parent === rootNode.id);
                return layerNodes.some(layerNode => {
                    const labelNodes = this.GET_filteredNodes.filter(node => node.layout.parent === layerNode.id);
                    return labelNodes.some(labelNode => {
                        return reportUtils.labelSearchForReportMatches(labelNode, searchTerm);
                    });
                });
            });

            this.refreshCurrentCursor();
        },

        resetCurrentCursor() {
            this.search.cursor.position = 0;
            this.search.cursor.labelId = null;
            this.refreshCurrentCursor()
        },

        refreshCurrentCursor() {
            this.search.cursor.labelId = this.currentFilteredNodesBySearchTerm[this.search.cursor.position]?.id ?? null;
            console.log('search.cursor.labelId: ', this.search.cursor.labelId);
            evtBus.$emit('evt_pesquisaAnotacoes_onCursorChange', this.search.cursor.labelId);
        },
    },

    // -----------------------------------------------------------------        

    mounted() {
        this.filteredRootNodes = this.GET_rootNodes;

        this.activeNode = {
            step: this.$store.state.runtime.active.step ?? null,
            layer: this.$store.state.runtime.active.layer ?? null,
            label: this.$store.state.runtime.active.label ?? null,
        }

        evtBus.$on('evt_pesquisaAnotacoes_action', (action, payload) => {
            // console.log('evt_pesquisaAnotacoes_action: ', action, payload);
            switch (action) {
                case 'search':
                    this.onSearchActionEvent(payload.searchTerm ?? '');
                    break;
                case 'cursorMove':
                    this.onSearchActionCursorMove(payload.direction);
                    break;
                case 'cursorSelectTerm':
                    this.onSearchActionCursorSelectTerm();
                    break;
            }
        });

        this.$updateFilteredRootNodes = _.debounce(this.updateFilteredRootNodes, 150);
    },

    // -----------------------------------------------------------------        
    
    created() {
        evtBus.$on('evt_relatorioDinamico_activateNode', this.handleActivateNode);

        // evtBus.$on('evt_nodeSearchAction', this.handleNodeSearchAction);
    }

    // -----------------------------------------------------------------

};
</script>

// =========================================================================================
// =========================================================================================

<style>

.pesquisa-anotacoes-container {
    display: flex;
    flex-direction: column;
    cursor: default;
}

.pesquisa-anotacoes__header {
    display: flex;
    align-items: center;
    gap: var(--spacing);
    padding: var(--spacing-sm) var(--spacing);
    background-color: var(--background-gray);
    border-bottom: 1px solid var(--border-primary);
}

.input__container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: var(--spacing);
    padding: var(--spacing-sm);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-md);
    background-color: var(--background-white);
    color: var(--color-primary);
    transition: box-shadow 0.2s ease;
}

.input__container:focus-within {
    box-shadow: 0 0 8px 1px color-mix(in srgb, var(--color-primary) 50%, transparent);
}

.input__icon {
    width: 20px;
    height: 20px;
}

.input__icon--clear {
    cursor: pointer;
    transition: opacity 0.2s ease;
}

.input__icon--clear:hover {
    opacity: 0.8;
}

.input__field {
    border: none;
    outline: none;
    font-size: var(--text-md);
    font-weight: 400;
    color: var(--color-primary);
    font-family: var(--font-family-primary);
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 10;
}

.input__field::placeholder {
    color: color-mix(in srgb, var(--color-primary) 60%, transparent);
    font-size: var(--text-sm);
    font-weight: 400;
    font-family: var(--font-family-primary);
}


.pesquisa-anotacoes__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    overflow-y: auto;
    height: 100%;
    max-height: calc(100vh - 200px);
    /* Firefox scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: var(--color-black) transparent;
    padding: var(--spacing);
}

/* Webkit scrollbar styling */
.pesquisa-anotacoes__content::-webkit-scrollbar {
    width: 8px;
}

.pesquisa-anotacoes__content::-webkit-scrollbar-track {
    background: transparent;
}

.pesquisa-anotacoes__content::-webkit-scrollbar-thumb {
    background: var(--color-black);
    border-radius: var(--radius-sm);
}

.pesquisa-anotacoes__content::-webkit-scrollbar-thumb:hover {
    background: var(--color-black);
}

.pesquisa-anotacoes__header-title {
    margin: 0;
    padding: 0;
    font-family: var(--font-family-primary);
    font-size: 20px;
    font-weight: 700;
    color: var(--color-primary);
}

.ulMain {
    list-style: none;
    padding-left:0px;
    margin-top: 0px;
    position: relative;
    height: 100%;
    top: 0px;
    left: 0px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.nodeTransition-enter-active {
    transition: opacity 0.2s ease-in;
}

.nodeTransition-leave-active {
    transition: opacity 0s;
}

.nodeTransition-enter-to, .step-leave {
    opacity: 1;
}

.nodeTransition-enter, .nodeTransition-leave-to {
    opacity: 0;
}

</style>